export default [
    {
        "id":1,
        "title_ar":"العربية",
        "title_en":"Arabic"
    },
    {
        "id":2,
        "title_ar":"الإنجليزية",
        "title_en":"English"
    },
    {
        "id":3,
        "title_ar":"التركية",
        "title_en":"Turkish"
    },
    {
        "id":4,
        "title_ar":"الفرنسية",
        "title_en":"French"
    },
    {
        "id":5,
        "title_ar":"الألمانية",
        "title_en":"German"
    },
    {
        "id":6,
        "title_ar":"الإسبانية",
        "title_en":"Spanish"
    },
    {
        "id":7,
        "title_ar":"الإيطالية",
        "title_en":"Italian"
    },
    {
        "id":8,
        "title_ar":"الصينية",
        "title_en":"Chinese"
    },
    {
        "id":9,
        "title_ar":"اليابانية",
        "title_en":"Japanese"
    },
    {
        "id":10,
        "title_ar":"الكورية",
        "title_en":"Korean"
    },
    {
        "id":11,
        "title_ar":"الروسية",
        "title_en":"Russian"
    },
]